import { useEffect, useMemo, useRef } from "react";

import { getInternalContainer } from "@/util/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

/**
 * Returns the nearest ancestor with a `data-portal-container` attribute.
 */
export function usePortalContainer({
  fromElement,
}: {
  /**
   * The element to start searching from. If not set, the fallback container is used.
   */
  fromElement?: React.RefObject<HTMLElement>;
}) {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  const element = useMemo(() => {
    return (
      // Find the nearest ancestor with data-portal-container
      fromElement?.current?.closest("[data-portal-container]") ??
      getInternalContainer() ??
      fromElement?.current?.ownerDocument.body ??
      globals.document?.body ??
      null
    );
  }, [isMounted, fromElement?.current]);

  return element;
}
